import { featuresData } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-12">
          为什么选择我们
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${item.icon} text-primary-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}